import styled from 'styled-components';

const TileStyled = styled.div`
  height:100%;
  background-color:#333;
  aspect-ratio:1/2;
  .evt-image {
    width:100%;
    img {
      width:100%;
    }
  }
  .evt-desc {
    padding:15px;
    font-size:16px;
    color:#ffff41;
    font-family:aleolight;
    .titre {
      font-family:aleobold;
      font-size:24px;
    }
    .num {
      font-family:aleobold;
      margin:0 10px;
      font-size:24px;
    }
  }
`;
export default TileStyled;
